export default {
      id: "pdf-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#pdf",
      toString: function () {
        return this.url;
      }
    }